import type { CSSProperties } from 'react';

interface ImageProps {
  src: string;
  alt?: string;
  fit?: 'contain' | 'cover' | 'fill' | 'none';
  className?: string;
  style?: CSSProperties;
}

export function ImageView({ src, alt = '', fit = 'contain', className, style }: ImageProps) {
  return (
    <img
      src={src}
      alt={alt}
      className={`max-w-full rounded${className ? ` ${className}` : ''}`}
      style={{ objectFit: fit, ...style }}
    />
  );
}
